module.exports = __webpack_public_path__ + "assets/profile_white.c1399cb7.svg";